<template>
  <div class="all-table" v-loading="loading">
    <div class="all-option">
    	<div class="all-option-one">
    		<ul class="clearfix">
    			<li v-for="(item,index) in category" :key="index"><a @click="chooseCategory(item)" href="javascript:;" :class="{'option-one-state':item.ischeck}">{{item.categoryName}}</a></li>
    		</ul>
    	</div>
    	<div class="all-option-two" v-show="categoryChild.length > 0">
    		<ul class="clearfix">
          <li v-for="(item,index) in categoryChild" :key="index">
            <a @click="chooseCategoryChild(item)" href="javascript:;" :class="{'option-two-state':item.ischeck}">{{item.categoryName}}</a>
          </li>
    		</ul>
    	</div>
    </div>

    <div >
        <CourseList :frompage="frompage" @pagechange="pagechange" :total="total" :list="courselist"></CourseList>
    </div>
  </div>
</template>

<script>
import '../../assets/css/allcourse.css'
import {ApiGetCategory,ApiGetCategoryChild} from '../../net/course/index.js'
import CourseList from '../CourseList/courseList.vue'
export default {
  data: function () {
    return {
      str: '所有课程',
      category : [],
      categoryChild : [],
      courselist :[],
      params : {},
      loading : false,
      item : {id : 0},
      clicktype : 0,
      total : 20,
      pageNum : 1,
      frompage : 'AllCourse'
    }
  },
  components: {
    CourseList
  },

  methods:{
    getgory(){
      ApiGetCategory().then(res=>{
        if(res.code == 200){
          this.category = res.value.map(function(item){
            return {...item,ischeck:item.id == 0 }
          })
        }
        this.loading = false
      })
    },
    chooseCategory(item){
      if(!item.ischeck){
        this.clicktype = 0;
        this.category = this.category.map(function(i){
          return {...i,ischeck : i.id == item.id }
        })
        this.item = item;
        this.getCourse(1)
      }
    },
    chooseCategoryChild(item){
        if(!item.ischeck){
          this.clicktype = 1;
          this.categoryChild = this.categoryChild.map(function(i){
            return {...i,ischeck : i.id == item.id}
          })
          this.item = item;
          this.getCourse(1)
        }
    },
    getCourse(index){
      this.loading = true
      const params= {
        category : this.item.id,
        pageNum : index,
        pageSize : 20,
        platform : 'pc'
      }
      ApiGetCategoryChild(params).then(res=>{
        if(res.code == 200){
          this.total = res.pc.page.total
          if(this.clicktype == 0){//点击6要素
            if(res.pc.categories.length > 0){
              this.categoryChild = res.pc.categories.map(function(i){
                return {...i,ischeck:false}
                })
            }else{
              this.categoryChild = [];
            }
            this.courselist = res.pc.page.details;
          }else{//点击子要素
            this.courselist = res.pc.page.details;
          }

        }
        this.loading = false
      })
    },
    pagechange(index){
      this.getCourse(index);
    }
  },
  mounted() {
    this.getgory();
    this.getCourse(1)
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/AllCourse/AllCourse.vue